import { useGetParams } from '../../hooks/useGetParams';

import styles from './QuizContainer.module.css';

import Advt from '../Advt/Advt';
import Quiz from '../Quiz/Quiz';
import { BgVideo } from '../BgVideo/BgVideo';

export const QuizContainer = ({ voteState, currentState, prevState }) => {
  const { marginTopQuiz } = useGetParams();

  return (
    <div className={styles.quizWrapper}>
      <Advt prevState={prevState} />

      <Quiz
        variants={voteState?.vars}
        title={voteState?.title}
        questionImgUrl={voteState?.questionImgUrl}
        currentState={currentState}
        marginTopQuiz={marginTopQuiz}
        idVote={voteState?.id}
      />

      <BgVideo />
    </div>
  );
};
